import { useMemo } from 'react'
import { useMediaQuery } from '@material-ui/core'

const useBreakpoints = () => {
  const isTablet = useMediaQuery('(min-width: 600px)');
  const isDesk = useMediaQuery('(min-width: 1280px)');
  const isMobile = useMemo(() => !isTablet && !isDesk, [isTablet, isDesk])

  return {
    isMobile,
    isTablet,
    isDesk
  }
}

export default useBreakpoints